<template>
  <b-modal ref="modal" hide-footer title="Product image">
    <div class="d-block text-center">
      <b-img :src="details.image" fluid alt="No image"></b-img>
    </div>
    <div class="border bg-light rounded text-dark flex-column">
      <p class="pt-3 pl-3"><strong>OEM codes: </strong>{{details.oems || 'No OEM codes for this product'}}</p>
    </div>
    <div class="mt-1 border bg-light rounded text-dark text-center flex-column">
      <p class="pt-3 pl-3"><a :href="details.link" target="_blank" rel="noopener noreferrer">View article on bdbildeler.no</a></p>
    </div>
    <b-button class="mt-3" variant="outline-danger" block @click="$refs.modal.hide()">Close</b-button>
  </b-modal>
</template>

<script>
// The product popup of /local-stock: image, OEM codes and web shop link of a
// Kwiky product. Open it with this.$refs.<ref>.show(article).
export default {
  name: 'ProductDetails',
  data: () => ({
    details: { image: null, link: null, oems: '' },
  }),
  methods: {
    // Reports false, without opening, when the product has neither an image
    // nor OEM codes.
    show(article) {
      const oems = (article?.productCodes?.productCode || [])
        .filter((c) => c.abbreviation === 'OEM')
        .map((c) => c.code)
        .join(', ');
      this.details = {
        image: article?.images?.image ? article.images.image[0].url : null,
        link: article?.URL || null,
        oems,
      };
      if (!this.details.image && !oems) return false;

      this.$refs.modal.show();
      return true;
    },
  },
};
</script>
